class AccordionAnimation {
  constructor() {
    this.init();
  }

  init() {
    // Find all animated accordions
    const animatedAccordions = document.querySelectorAll('.accordion--animated');
    
    animatedAccordions.forEach(accordion => {
      this.setupAccordion(accordion);
    });
  }

  setupAccordion(accordion) {
    const details = accordion.querySelector('details');
    const content = accordion.querySelector('.accordion__content');
    const summary = accordion.querySelector('summary');
    
    if (!details || !content || !summary) return;

    // Get animation settings from data attributes
    const duration = accordion.dataset.animationDuration || 'normal';
    const easing = 'ease'; // Fixed easing for consistent feel
    
    // Convert duration to milliseconds
    const durationMap = {
      'fast': 200,
      'normal': 300,
      'slow': 500
    };
    
    const animationDuration = durationMap[duration] || 300;

    // Set initial state
    content.style.maxHeight = '0px';
    content.style.overflow = 'hidden';
    content.style.transition = `max-height ${animationDuration}ms ${easing}, padding ${animationDuration}ms ${easing}, margin ${animationDuration}ms ${easing}`;

    // Handle accordion toggle
    summary.addEventListener('click', (e) => {
      e.preventDefault();
      
      if (details.open) {
        this.closeAccordion(details, content, animationDuration);
      } else {
        this.openAccordion(details, content, animationDuration);
      }
    });

    // Handle keyboard navigation
    summary.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        
        if (details.open) {
          this.closeAccordion(details, content, animationDuration);
        } else {
          this.openAccordion(details, content, animationDuration);
        }
      }
    });
  }

  openAccordion(details, content, duration) {
    // Set open attribute first
    details.open = true;
    
    // Temporarily set to auto to get the actual height
    content.style.maxHeight = 'none';
    const height = content.scrollHeight;
    content.style.maxHeight = '0px';
    
    // Force reflow
    content.offsetHeight;
    
    // Set the final height
    content.style.maxHeight = height + 'px';
    
    // Reset max-height after animation completes
    setTimeout(() => {
      content.style.maxHeight = 'none';
    }, duration);
  }

  closeAccordion(details, content, duration) {
    // Get current height
    const height = content.scrollHeight;
    content.style.maxHeight = height + 'px';
    
    // Force reflow
    content.offsetHeight;
    
    // Animate to 0
    content.style.maxHeight = '0px';
    
    // Set closed attribute after a delay to allow animation to complete more naturally
    setTimeout(() => {
      details.open = false;
    }, 300);
    
    // Clean up after animation completes
    setTimeout(() => {
      content.style.maxHeight = '0px';
    }, duration);
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new AccordionAnimation();
});

// Re-initialize for dynamic content (like in theme editor)
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    new AccordionAnimation();
  });
}
